import { Frame, store } from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  provide(this: ContextMenuComponent) {
    return { contextMenu: this }
  },
})
export class ContextMenuComponent extends Vue {
  @Prop({ required: true })
  frame!: Frame

  lastEvent!: MouseEvent

  saveMouseEvent(e: MouseEvent) {
    this.lastEvent = e
    return {
      x: e.clientX,
      y: e.clientY,
      direction: 'right',
    }
  }

  coord() {
    const globe = store.currentGlobe()
    return globe.canvas.coordFromClientCoord(this.lastEvent)
  }
}
